module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-3-Social-Static-Ad-w540.284de115.webp";